import type { Address } from "viem"
import type { Config } from "wagmi"

import type { EmitEvent } from "@/domains/core"
import { EventEmitter } from "@/domains/library"
import { claimLpReward } from "@/domains/on-chain"

export type ClaimLpRewardInteractionParams = {
  account: Address
  chainId: number
  config: Config
  gaugeAddress: Address
  tokenAddress: Address
  pairDisplayName: string
  emitter: EventEmitter<EmitEvent>
}

export const claimLpRewardInteraction = async ({
  account,
  chainId,
  config,
  gaugeAddress,
  tokenAddress,
  pairDisplayName,
  emitter,
}: ClaimLpRewardInteractionParams) => {
  emitter.emit("claiming-lp-rewards", {
    title: "Claiming LP rewards",
    description: `Claiming rewards for ${pairDisplayName}`,
    variant: "info",
  })

  const result = await claimLpReward({
    account,
    chainId,
    config,
    gaugeAddress,
    tokenAddress,
  })

  if (result.success === true) {
    emitter.emit("claimed-lp-rewards", {
      title: "Claim LP rewards",
      description: `Claimed rewards for ${pairDisplayName}`,
      variant: "success",
    })
    return result
  }

  emitter.emit("error-claiming-lp-rewards", {
    title: "Claim LP rewards",
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    description: result.error,
    variant: "error",
  })

  return false
}
